import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';

import { ReportService } from '../../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TicketService } from '../../../../../common/services/Ticket.service';
import { TicketTypeService } from '../../../../../common/services/TicketType.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { PriorityService } from '../../../../../common/services/Priority.service';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { ToastrService } from 'ngx-toastr';
import { ChannelConst, Filter } from './channel.const';
import { QueueVoiceManager, ReportGroupBy } from '../filter/filter.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import { CampaignService } from '../../../../../common/services/Campaign.service';
import { QueueService } from '../../../../../common/services/Queue.service';
import * as _ from 'lodash';

declare var $: any;
declare var Chartist: any;

@Component({
  selector: 'report-channel',
  templateUrl: 'channel.template.html',
  styleUrls: ['../report.component.css'],
  providers: [
    ReportService,
    TicketService,
    GroupService,
    UserService,
    TicketTypeService,
    QueueService,
    CampaignService,
    ServiceService,
    PriorityService,
    ExportService,
  ],
})
export class ChannelComponent implements OnInit {
  public modelFilter: any = {};
  public data: any;
  public data_page_divide: any;
  public exportData: any = [];
  public queues: any = [];
  public campaigns: any = [];
  public displayColumns: any = [];
  public groupBys = Filter;
  totalPage = 0;
  totalItem = 0;
  currentPage = 1;

  constructor(
    private reportService: ReportService,
    private exportService: ExportService,
    private queueService: QueueService,
    private campaignService: CampaignService,
    private toastr: ToastrService
  ) {
    const user = JSON.parse(localStorage.getItem('User'));
    this.modelFilter = {
      from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm'),
      source: '-1',
      tenantId: user.tenant_id,
      groups: '',
      queues: '',
      calleds: '',
      campaigns: '',
      agents: '',
      groupBy: `${ReportGroupBy.Day},${ReportGroupBy.Source}`,
    };
    this.displayColumns = ChannelConst.displayColumns(this.modelFilter.groupBy);
  }

  ngOnInit() {
    this.getAllCampaign();
    this.getAllQueue();
    this.loadChannel(1);
  }

  changeTime(type) {
    let start: any = moment().format('YYYY-MM-DD HH:mm');

    const end: any = moment().format('YYYY-MM-DD HH:mm');

    switch (type) {
      case 'year': {
        // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
        start = moment().add('-365', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'month': {
        // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
        start = moment().add('-30', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'week': {
        // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
        start = moment().add('-7', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'day': {
        // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
        start = moment().add('-1', 'days').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'hour': {
        start = moment().add('-1', 'hours').format('YYYY-MM-DD HH:mm');
        break;
      }
      case 'minute': {
        start = moment().add('-30', 'minutes').format('YYYY-MM-DD HH:mm');
        break;
      }
      default:
        break;
    }
    this.modelFilter['from'] = start;
    this.modelFilter['to'] = end;
    this.loadChannel(1);
  }

  loadChannel(research?: any) {
    if (research) {
      this.currentPage = 1;
    }
    const filter = _.assign({}, this.modelFilter);
    if (Array.isArray(filter.groupBy)) {
      filter.groupBy = filter.groupBy.join(',');
    }
    if (Array.isArray(filter.groups)) {
      filter.groups = filter.groups.join(',');
    }
    if (Array.isArray(filter.queues)) {
      filter.queues = filter.queues.join(',');
    }
    if (Array.isArray(filter.calleds)) {
      filter.calleds = filter.calleds.join(',');
    }
    if (Array.isArray(filter.campaigns)) {
      filter.campaigns = filter.campaigns.join(',');
    }
    if (Array.isArray(filter.agents)) {
      filter.agents = filter.agents.join(',');
    }
    this.reportService.reportChannel(filter).subscribe(res => {
      if (res.data) {
        this.data = res.data;
      } else {
        this.data = [
          {
            dt: null,
            source: 0,
            totalCalls: 0,
            totalMissCalls: 0,
            totalAnswerCalls: 0,
            avgSpeedAnswer: 0,
            avgAcdTime: 0,
            avgDuration: 0,
            avgHoldTime: 0,
            avgWaitingTime: 0,
            totalAcdTime: 0,
            missRatio: 0,
            slaRatio: 0,
            slaRatio20: 0,
          },
        ];
      }
      this.data.map(res => {
        const campaign = this.campaigns.find(c => c.id == res.campaignId);
        const queue = this.queues.find(c => c.id == res.queueId);
        res.missRatio = ChannelConst.displayMissRatioColumn(res.missRatio);
        res.slaRatio20 = ChannelConst.displayMissRatioColumn(res.slaRatio20);
        res.slaRatio = ChannelConst.displayMissRatioColumn(res.slaRatio);
        res.avgSpeedAnswer = TimeWorker.formatSecondToHour(res.avgSpeedAnswer);
        res.avgAcdTime = TimeWorker.formatSecondToHour(res.avgAcdTime);
        res.avgDuration = TimeWorker.formatSecondToHour(res.avgDuration);
        res.avgHoldTime = TimeWorker.formatSecondToHour(res.avgHoldTime);
        res.avgWaitingTime = TimeWorker.formatSecondToHour(res.avgWaitingTime);
        res.avgMissDuration = TimeWorker.formatSecondToHour(res.avgMissDuration);
        res.longestAcdTime = TimeWorker.formatSecondToHour(res.longestAcdTime);
        res.campaignId = campaign ? campaign.text : '';
        res.queueId = queue ? queue.text : '';
        return res;
      });
      this.totalItem = this.data.length;
      this.totalPage =
        this.data.length % 10 != 0 ? Math.floor(this.data.length / 10) + 1 : Math.floor(this.data.length / 10);
      const begin = (this.currentPage - 1) * 10;
      const end = this.currentPage * 10;
      this.data_page_divide = this.data.slice(begin, end);
    });
  }

  submitFilter(item?: any) {
    if (item) {
      this.modelFilter = item;
    }
    if (this.modelFilter.from) {
      this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
    }
    if (this.modelFilter.to) {
      this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');
    }
    this.displayColumns = ChannelConst.displayColumns(this.modelFilter.groupBy);
    this.loadChannel(1);
  }

  export() {
    this.exportData = [];
    this.data.forEach(data => {
      const dataExport = {};
      this.displayColumns.forEach(d => {
        dataExport[d.title] = data[d.key];
      });
      this.exportData.push(dataExport);
    });
    this.exportService.exportExcel(
      this.exportData,
      'Báo cáo hoạt động đa kênh ' + moment(new Date()).format('YYYY-MM-DD HH-mm')
    );
  }

  getAllQueue() {
    this.queueService.list({}).subscribe(res => {
      if (res.status == 200) {
        const queueList = [];
        res.data.queues.forEach((c: any) => {
          queueList.push({
            text: c.DESCRIPTION,
            id: c.QUEUE_ID.toString(),
          });
        });
        this.queues = queueList;
      }
    });
  }

  getAllCampaign() {
    this.campaignService.all({}).subscribe(res => {
      const campaignList = [];
      res.data.list.forEach((c: any) => {
        campaignList.push({
          text: c.name,
          id: c._id,
        });
      });
      this.campaigns = campaignList;
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadChannel();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadChannel();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/report/channels/channel.component.ts